import React from "react";

import ConfirmModal from "./ConfirmModal";

class ConfirmDeleteModal extends React.Component {
  constructor() {
    super();
  }

  render() {
    const {
      title,
      content,
      color,
      isOpen,
      icon,
      confirmButtonText,
      cancelButtonText,
      confirmAction,
      cancelAction,
      afterClose,
      waitForAction,
      isLoading,
      loadingText,
      isSuccess,
      successText,
      isError,
      errorText
    } = this.props;

    return (
      <ConfirmModal
        title={title}
        content={content}
        color={color}
        isOpen={isOpen}
        icon={icon}
        confirmButtonText={confirmButtonText}
        cancelButtonText={cancelButtonText}
        confirmAction={confirmAction}
        cancelAction={cancelAction}
        afterClose={afterClose}
        waitForAction={true}
        isLoading={isLoading}
        loadingText={"Usuwam"}
        isSuccess={isSuccess}
        successText={"Usunięto pozycję"}
        isError={isError}
        errorText={"Błąd przy usuwaniu. Spróbuj ponownie."}
        successTitle={"SUKCES"}
      />
    );
  }
}

export default ConfirmDeleteModal;



// WEBPACK FOOTER //
// ./src/browser/components/ConfirmModal/ConfirmDeleteModal.js